import React, { useEffect } from "react";
import styled from "styled-components";
import SVGButton from "../Buttons/SVGButton";
import deleteIcon from "../../Images/Delete.svg";
import { TAX_LIST } from "../../utilities/constants";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import { useFormikContext } from "formik";
import FormikSelect from "../Formik/FormikSelect";
import FormikInput from "../Formik/FormikInput";

const minWidth = 250;
const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 15px;
  padding: 13px;
`;

const Button = styled.button`
  background-color: #fff;
  color: #ff5837;
  border: none;
  font-weight: 600;
  width: 130px;
  min-width: 150px;
  height: 40px;
  margin-right: 110px;
  outline: none; /* Remove default button outline */
`;

const OptionalProducts = ({
  keyName,
  productList,
  handleChangeProduct,
  disabled,
}) => {
  const { language, translations } = useLanguage();
  const t = translations[language];

  const { values, setFieldValue } = useFormikContext();

  const addRow = () => {
    const newRow = {
      product_id: "",
      name: "",
      product_uom_qty: 1,
      price_unit: 0,
      tax_id: "",
      discount: 0,
      price_subtotal: "",
    };
    setFieldValue(keyName, [...values[keyName], newRow]);
  };

  const removeRow = (index) => {
    const newRows = [...values[keyName]];
    newRows.splice(index, 1);
    setFieldValue(keyName, newRows);
  };

  const handleChangeProductId = (option, e, index) => {
    handleChangeProduct({
      option,
      index,
      setFieldValue,
      keyName,
      values: values[keyName][index],
    });
  };
  useEffect(() => {
    if (values?.[keyName]?.length > 0) {
      values?.[keyName]?.forEach((item, index) => {
        const itemPrice = Number(item?.price_unit) || 0;
        const itemQuantity = Number(item?.product_uom_qty) || 0;
        const taxID = Number(item.tax_id) || 0;
        const totalAmount = itemPrice * itemQuantity;
        const totalDiscount = Number(item.discount) || 0;
        let taxAmount = 0;
        if (taxID) {
          taxAmount = totalAmount * 0.15;
        }
        setFieldValue(
          `${keyName}.${index}.price_subtotal`,
          totalAmount + taxAmount - totalDiscount
        );
      });
    }
  }, [values]);
  return (
    <>
      <TableContainer>
        <table className="table">
          <thead>
            <tr>
              <th style={{ minWidth }}>{t["Product"]}</th>
              <th style={{ minWidth }}>{t["Description"]}</th>
              <th style={{ minWidth }}>{t["Quantity"]}</th>
              <th style={{ minWidth }}>{t["Unit Price"]}</th>
              <th style={{ minWidth }}>{t["Tax%"]}</th>
              <th style={{ minWidth }}>{t["Discount"]}</th>
              <th style={{ minWidth }}>{t["Total"]}</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {values?.[keyName]?.map((row, index) => (
              <tr key={index}>
                <td>
                  <FormikSelect
                    disabled={disabled}
                    menuPosition="fixed"
                    name={`${keyName}.${index}.product_id`}
                    options={productList}
                    onChange={(option, e) =>
                      handleChangeProductId(option, e, index)
                    }
                  />
                </td>
                <td>
                  <FormikInput
                    name={`${keyName}.${index}.name`}
                    disabled={disabled}
                  />
                </td>
                <td>
                  <FormikInput
                    name={`${keyName}.${index}.product_uom_qty`}
                    type="number"
                    disabled={disabled}
                  />
                </td>
                <td>
                  <FormikInput
                    name={`${keyName}.${index}.price_unit`}
                    type="number"
                    disabled={disabled}
                  />
                </td>
                <td>
                  <FormikSelect
                    name={`${keyName}.${index}.tax_id`}
                    menuPosition="fixed"
                    options={TAX_LIST}
                    disabled={disabled}
                  />
                </td>
                <td>
                  <FormikInput
                    name={`${keyName}.${index}.discount`}
                    type="number"
                    disabled={disabled}
                  />
                </td>
                <td>
                  <FormikInput
                    name={`${keyName}.${index}.price_subtotal`}
                    type="number"
                    disabled={disabled}
                  />
                </td>
                <td>
                  <SVGButton
                    disabled={disabled}
                    onClick={() => removeRow(index)}
                    icon={deleteIcon}
                    hoverColor="silver"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </TableContainer>
      {!disabled && (
        
        <Button role="button" type="button" onClick={addRow}>
          + Add a Product
        </Button>
      )}
    </>
  );
};

export default OptionalProducts;
